import { Image } from "antd"
import { observer } from "mobx-react"
import React from "react"
import ExpertPC from "../../assets/Header/ExpertPC.svg"
import LogoPC from "../../assets/Header/ICICI-Life.png"
import LogoMob from "../../assets/Header/ICICI-Life-MOB.png"
import AppStore from "../../Configs/Store/index"
import ModalStore from "../../Configs/Store/modals"
import { DataLayerFn } from "../../Configs/API"
import CalculatorStore from "../../Configs/Store/calculator"
import "./Header.less"

const HeaderModule = observer(({ type }) => {
  const handlemodalOpen = () => {
    ModalStore.setTalk2Expert(true)
    try {
      DataLayerFn(`TalkToExpert_Selected`, CalculatorStore, "Consult an expert")
    } catch {}
  }

  const homePage = () => {
    window.location = "https://www.icicilife.com/"
  }

  return (
    <div className="headerMain">
      <div className="headerParent">
        <div className="headerChild">
          <Image preview={false} className="icic-logo-image" srcSet={AppStore.device === 0 ? LogoMob : LogoPC} onClick={homePage} />
        </div>
        <div className="headerSideItems">
          <div className="headerExpert-btn" onClick={handlemodalOpen}>
            <img src={ExpertPC} alt={"Talk To Expert"} className="headerExpert_Image" />
            <div className="headerExpert_Text"> Talk to an Expert </div>
          </div>
        </div>
      </div>
    </div>
  )
})

export default HeaderModule
